import * as tslib_1 from "tslib";
import isFunction from 'lodash/isFunction';
import isPlainObject from 'lodash/isPlainObject';
import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';
import startsWith from 'lodash/startsWith';
import { Router } from './router';
export function flatMap(collection, fn) {
    var e_1, _a;
    var flattened = [];
    try {
        for (var collection_1 = tslib_1.__values(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()) {
            var i = collection_1_1.value;
            var ret = fn(i);
            if (Array.isArray(ret)) {
                flattened.push.apply(flattened, tslib_1.__spread(ret));
            }
            else {
                flattened.push(ret);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return flattened;
}
export function sequence(callbacks) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_2, _a, count, success, callbacks_1, callbacks_1_1, _fn, ret, e_2_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    count = 0;
                    success = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    callbacks_1 = tslib_1.__values(callbacks), callbacks_1_1 = callbacks_1.next();
                    _b.label = 2;
                case 2:
                    if (!!callbacks_1_1.done) return [3 /*break*/, 5];
                    _fn = callbacks_1_1.value;
                    count++;
                    return [4 /*yield*/, promisify(_fn).apply(void 0, tslib_1.__spread(args))];
                case 3:
                    ret = _b.sent();
                    if (ret === false) {
                        success = false;
                        return [3 /*break*/, 5];
                    }
                    _b.label = 4;
                case 4:
                    callbacks_1_1 = callbacks_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/, { count: count, success: success }];
            }
        });
    });
}
export function traversePath(router, path) {
    if (path.indexOf('//') === 0) {
        path = path.replace('//', '/');
        while (!router.isRoot) {
            router = router.ctx.$parent.router;
        }
    }
    else {
        if (path.indexOf('./') === 0) {
            path = path.replace('./', '/');
            router = router.ctx.$child.router;
        }
        while (path && path.match(/\/?\.\./i) && !router.isRoot) {
            router = router.ctx.$parent.router;
            path = path.replace(/\/?\.\./i, '');
        }
    }
    return { router: router, path: path };
}
export function resolveHref(_a) {
    var router = _a.router, path = _a.path;
    return router.ctx.base + path;
}
export function isActivePath(_a) {
    var router = _a.router, path = _a.path;
    var ctx = router.ctx;
    while (ctx) {
        // create dependency on isNavigating so that this works with nested routes
        // inside a computed
        ctx.router.isNavigating();
        if (ctx.$child ? startsWith(path, ctx.pathname) : path === ctx.pathname) {
            path = path.substr(ctx.pathname.length) || '/';
            ctx = ctx.$child;
        }
        else {
            return false;
        }
    }
    return true;
}
export function isThenable(x) {
    return !isUndefined(x) && isFunction(x.then);
}
export function promisify(_fn) {
    var _this = this;
    if (_fn === void 0) { _fn = noop; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var fn, ret, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fn = function () {
                            return _fn.length === args.length + 1
                                ? new Promise(function (r) {
                                    _fn.apply(void 0, tslib_1.__spread(args, [r]));
                                })
                                : _fn.apply(void 0, tslib_1.__spread(args));
                        };
                        ret = fn();
                        if (!isThenable(ret)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ret];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = ret;
                        _b.label = 3;
                    case 3: return [2 /*return*/, _a];
                }
            });
        });
    };
}
export function castLifecycleObjectMiddlewareToGenerator(fn) {
    return function (ctx) {
        return tslib_1.__asyncGenerator(this, arguments, function () {
            var e_3, _a, ret, ret_1, ret_1_1, v, e_3_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, tslib_1.__await(promisify(fn)(ctx))];
                    case 1:
                        ret = _b.sent();
                        if (!(ret && isFunction(ret.next))) return [3 /*break*/, 17];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 10, 11, 16]);
                        ret_1 = tslib_1.__asyncValues(ret);
                        _b.label = 3;
                    case 3: return [4 /*yield*/, tslib_1.__await(ret_1.next())];
                    case 4:
                        if (!(ret_1_1 = _b.sent(), !ret_1_1.done)) return [3 /*break*/, 9];
                        v = ret_1_1.value;
                        return [4 /*yield*/, tslib_1.__await(v)];
                    case 5: return [4 /*yield*/, tslib_1.__await.apply(void 0, [_b.sent()])];
                    case 6: return [4 /*yield*/, _b.sent()];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8: return [3 /*break*/, 3];
                    case 9: return [3 /*break*/, 16];
                    case 10:
                        e_3_1 = _b.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 16];
                    case 11:
                        _b.trys.push([11, , 14, 15]);
                        if (!(ret_1_1 && !ret_1_1.done && (_a = ret_1.return))) return [3 /*break*/, 13];
                        return [4 /*yield*/, tslib_1.__await(_a.call(ret_1))];
                    case 12:
                        _b.sent();
                        _b.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        if (e_3) throw e_3.error;
                        return [7 /*endfinally*/];
                    case 15: return [7 /*endfinally*/];
                    case 16: return [3 /*break*/, 33];
                    case 17:
                        if (!isPlainObject(ret)) return [3 /*break*/, 30];
                        return [4 /*yield*/, tslib_1.__await(promisify(ret.beforeRender)())];
                    case 18: return [4 /*yield*/, tslib_1.__await.apply(void 0, [_b.sent()])];
                    case 19: return [4 /*yield*/, _b.sent()];
                    case 20:
                        _b.sent();
                        return [4 /*yield*/, tslib_1.__await(promisify(ret.afterRender)())];
                    case 21: return [4 /*yield*/, tslib_1.__await.apply(void 0, [_b.sent()])];
                    case 22: return [4 /*yield*/, _b.sent()];
                    case 23:
                        _b.sent();
                        return [4 /*yield*/, tslib_1.__await(promisify(ret.beforeDispose)())];
                    case 24: return [4 /*yield*/, tslib_1.__await.apply(void 0, [_b.sent()])];
                    case 25: return [4 /*yield*/, _b.sent()];
                    case 26:
                        _b.sent();
                        return [4 /*yield*/, tslib_1.__await(promisify(ret.afterDispose)())];
                    case 27: return [4 /*yield*/, tslib_1.__await.apply(void 0, [_b.sent()])];
                    case 28: return [4 /*yield*/, _b.sent()];
                    case 29:
                        _b.sent();
                        return [3 /*break*/, 33];
                    case 30: return [4 /*yield*/, tslib_1.__await(ret)];
                    case 31: return [4 /*yield*/, _b.sent()];
                    case 32:
                        _b.sent();
                        _b.label = 33;
                    case 33: return [2 /*return*/];
                }
            });
        });
    };
}
export function getRouterForBindingContext(bindingCtx) {
    while (!isUndefined(bindingCtx)) {
        if (!isUndefined(bindingCtx.$router)) {
            return bindingCtx.$router;
        }
        bindingCtx = bindingCtx.$parentContext;
    }
    return Router.head;
}
export var log = {
    error: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        // tslint:disable-next-line no-console
        console.error.apply(console, tslib_1.__spread(['[@profiscience/knockout-contrib-router]'], messages));
    },
    warn: function () {
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        // tslint:disable-next-line no-console
        console.warn.apply(console, tslib_1.__spread(['[@profiscience/knockout-contrib-router]'], messages));
    }
};
//# sourceMappingURL=utils.js.map